/**
 * Decodes a Base64 string to a Uint8Array.
 * Uses the browser's built-in atob function for decoding.
 *
 * @param data - Base64 encoded string
 * @returns Decoded bytes as Uint8Array
 *
 * @example
 * ```ts
 * import { Base64Decode } from "@pdfking/tfunc"
 *
 * const encoded = "SGVsbG8gV29ybGQ="
 * const bytes = Base64Decode(encoded)
 * const text = new TextDecoder().decode(bytes) // "Hello World"
 * ```
 */
export const Base64Decode = (data: string): Uint8Array => {
  const binaryString = atob(data)
  const bytes = new Uint8Array(binaryString.length)
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i)
  }
  return bytes
}
